import getCurrentSelectionRect from './getCurrentSelectionRect';
import { window } from '../../../../../helpers/BrowserHelpers';
var TOOLBAR_MARGIN = 8;
var MIN_CONTAINER_WIDTH = 580;
export default function setToolbarPlacement(editor, state, parent, toolbar, insets, commit) {
  var selectionRect = getCurrentSelectionRect(editor);

  if (!selectionRect || !state.isOpen) {
    return commit({
      isOpen: false,
      style: {}
    });
  }

  var parentRect = parent.getBoundingClientRect();
  var toolbarRect = toolbar.getBoundingClientRect();
  var isOpen = state.isOpen,
      isExpanded = state.isExpanded,
      isPrompt = state.isPrompt,
      isMinimal = state.isMinimal,
      command = state.command;

  if (isMinimal) {
    var top = selectionRect.top + selectionRect.height / 2 - (toolbarRect.height / 2 + TOOLBAR_MARGIN) - parentRect.top;
    return commit({
      isOpen: parentRect.width >= MIN_CONTAINER_WIDTH ? true : false,
      style: {
        top: top,
        right: 0
      },
      isExpanded: isExpanded,
      command: command
    });
  }

  var position = state.position;
  var left = -TOOLBAR_MARGIN + insets.left;
  var right = -TOOLBAR_MARGIN + insets.right;

  if ((!isExpanded || isPrompt) && command === null) {
    left = Math.min(Math.max(selectionRect.left - parentRect.left + selectionRect.width / 2 - toolbarRect.width / 2, -TOOLBAR_MARGIN + insets.left), parentRect.width - (toolbarRect.width + TOOLBAR_MARGIN));
    right = undefined;
  }

  var toolbarHeight = toolbarRect.height + TOOLBAR_MARGIN;
  var selectionTop = selectionRect.top + Math.abs(Math.min(0, selectionRect.top - insets.bottom));
  var selectionBottom = selectionRect.bottom + Math.abs(Math.min(0, selectionRect.bottom - insets.top));
  var willCropBottom = selectionBottom >= window.innerHeight - (toolbarHeight + insets.bottom);
  var willCropTop = selectionTop <= toolbarHeight + insets.top; // Switch toolbar position if it will be cropper by window edges

  if (position === 'bottom' && willCropBottom) {
    position = 'top';
  } else if (position === 'top' && willCropTop) {
    position = 'bottom';
  }

  if (position === 'bottom') {
    var _top = selectionBottom - parentRect.top;

    return commit({
      style: {
        left: left,
        right: right,
        top: _top
      },
      isOpen: isOpen,
      isExpanded: isExpanded,
      command: command
    });
  } else if (position === 'top') {
    var _top2 = selectionTop - parentRect.top;

    var bottom = parentRect.height - _top2;
    return commit({
      style: {
        left: left,
        right: right,
        bottom: bottom
      },
      isOpen: isOpen,
      isExpanded: isExpanded,
      command: command
    });
  }
}